<script setup>
import {computed, getCurrentInstance, onMounted, ref, watch} from "vue";
import { useRoute, useRouter } from "vue-router";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import moment from "moment/moment";
import jobFairCorpService from "../../../../user/services/jobFair/jobFairCorpService";
import fileService from "../../../../../services/fileService";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useAlertStore } from "../../../../../stores/alertStore";
import KSAInput from "@/components/ui-components/input/KSAInput.vue";
import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
const {$alert, $confirm} = useAlertStore();

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();
const { $gb, $fileSize } = getCurrentInstance().appContext.config.globalProperties;

const loaded = ref(false);
const emit = defineEmits(['go-back']);
const corporation = ref({
  corpId: '',
});

const residenceAreaRef = ref(null);

const corpUpdateIntroMovFileNameSize = ref(null); // 파일명 + 용량

// 사업자등록번호
const bizNumInput = ref('')

const corpUpdate = ref({
  ojfId: 0,
  bizNum: '', // 사업자등록번호
  corpName: '', // 기업명
  ceoName: '', // 대표자명
  residenceArea1: '', // 사업장소재지1
  residenceArea2: '', // 사업장소재지2
  bizType: '', // 업종
  industryGb: '', // 산업구분
  industryText: '', // 사업구분 기타
  corpGb: '', // 기업형태
  corpText: '', // 기업형태 기타
  foundYm: '', // 창립연월
  employeeNumGb: '', // 사원수(인원구분)
  salesAmtGb: "", // 매출액
  corpPublicYn: '', // 상장여부
  corpPublicGb: '',// 상장구분
  corpPublicText: '', // 상장구분 기타
  homeUrl: '', // 홈페이지
  ciImgName: '', // 로고이미지명
  ciImgSize: '', // 로고이미지용량
  ciImgDir: '', // 로고이미지위치
  bizLicenseName: '', // 사업자등록증명
  bizLicenseSize: '', // 사업자등록증용량
  bizLicenseDir: '', // 사업자등록증위치
  corpIntro: '', // 기업소개
  corpHistory: '', // 주요연혁
  corpIntroName: '', // 기업소개서명
  corpIntroSize: '', // 기업소개서용량
  corpIntroDir: '', // 기업소개서위치
  introMovGb: '', // 기업소개영상구분 01 영상 업로드 02 유튜브 영상(URL)
  introMovName: '', // 기업소개영상
  introMovSize: '',
  introMovDir: '',
  introYoutubeUrl: '' // 유튜브 URL
});
const errorInputCorp = ref({
  bizNum: '', // 사업자등록번호
  corpName: '', // 기업명
  ceoName: '', // 대표자명
  residenceArea: '', // 사업장소재지
  bizType: '', // 업종
  industryGb: '', // 산업군
  corpGb: '', // 기업형태
  foundYm: '', // 창립연월
  employeeNumGb: '', // 사원수
  salesAmtGb: '', // 매출액
  corpPublicYn: '', // 상장여부
  corpPublicGb: '', // 상장구분
  ciImg: '', // 로고이미지(CI)
  bizLicense: '', // 사업자등록증
});

const ojfCorporationDetail = () => {
  if (!corporation.value.corpId) {
    return;
  }

  loadingStore.loading = true;
  jobFairCorpService.ojfCorporationDetail(corporation.value.corpId)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;

          if (result.introMovGb !== undefined && result.introMovGb !== null && result.introMovGb !== '') {
            result.introMovGb = String(result.introMovGb).padStart(2, '0');
          }

          corpUpdate.value = result;

          // 사업자등록번호
          if(result.bizNum ) {
            const bizNum = result.bizNum;
            if(bizNum) {
              result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
            }
          }

          // 사업장소재지
          if(result.residenceArea1 && result.residenceArea2) {
            residenceAreaRef.value.initSelectedOption(result.residenceArea1, result.residenceArea2)
          }

          // 창립연월
          if(result.foundYm ) {
            const foundYm = result.foundYm;
            if(foundYm) {
              result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
            }
          }

          if (result.introMovName && result.introMovSize) {
            corpUpdateIntroMovFileNameSize.value = `${result.introMovName}  ${$fileSize(result.introMovSize)}`;
          } else {
            corpUpdateIntroMovFileNameSize.value = '';
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}


const formatBizNum = (event) => {
  validateText('bizNum', event.target.value);

  // 숫자만 필터링
  bizNumInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (bizNumInput.value.length >= 5) {
    corpUpdate.bizNum = `${bizNumInput.value.slice(0, 3)}-${bizNumInput.value.slice(0,2)}-${bizNumInput.value.slice(5)}`
  } else {
    corpUpdate.bizNum = bizNumInput.value
  }
}

// 사업장소재지
const onSelectedArea1Option = (option) => {
  corpUpdate.value.residenceArea1 = option;
  errorInputCorp.value.residenceArea = '';
}

const onSelectedArea2Option = (option) => {
  corpUpdate.value.residenceArea2 = option;
  errorInputCorp.value.residenceArea = '';
}

// 상장여부 초기화
const resetCorpPublic = (val) => {
  if (val === 'N') {
    corpUpdate.value.corpPublicGb = ''
    corpUpdate.value.corpPublicText = ''
  }
}

// 상장 기타 초기화
const resetCorpPublicText = (val) => {
  if (val === '05') {
    corpUpdate.value.corpPublicText = ''
  }
}

// 기업소개영상 업로드 양식 초기화
const resetFile = (val) => {
  if (val === 'N') {
    corpUpdate.value.introMovName = ''
    corpUpdate.value.introMovSize = ''
    corpUpdate.value.introMovDir = ''
    corpUpdateIntroMovFileNameSize.value = ''
  } else {
    corpUpdate.value.introYoutubeUrl = ''
  }
}

// 산업군 기타 초기화
const resetIndustryText = (val) => {
  if (val === '06') {
    corpUpdate.value.industryText = ''
  }
}

// 기업형태 기타 초기화
const resetCorpText = (val) => {
  if (val === '05') {
    corpUpdate.value.corpText = ''
  }
}

// 매출액
const clickSalesAmtGb = (option) => {
  corpUpdate.value.salesAmtGb = option.value;
  errorInputCorp.value.salesAmtGb = '';
}

// 로고이미지(CI) 업로드
const uploadFileCiImg = (corpUpdate) => {
  errorInputCorp.value.ciImg = '';
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'ciImg',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.ciImgName = result.originalFilename;
            corpUpdate.ciImgSize = result.fileSize;
            corpUpdate.ciImgDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 로고이미지(CI) 삭제
const removeFileCiImg = (corpUpdate) => {
  corpUpdate.ciImgName = '';
  corpUpdate.ciImgSize = '';
  corpUpdate.ciImgDir = '';
  errorInputCorp.value.ciImg = '';
}

// 사업자등록증 업로드
const uploadFileBizLicense = (corpUpdate) => {
  errorInputCorp.value.bizLicense = '';
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'bizLicense',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.bizLicenseName = result.originalFilename;
            corpUpdate.bizLicenseSize = result.fileSize;
            corpUpdate.bizLicenseDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 사업자등록증 삭제
const removeFileBizLicense = (corpUpdate) => {
  corpUpdate.bizLicenseName = '';
  corpUpdate.bizLicenseSize = '';
  corpUpdate.bizLicenseDir = '';
  errorInputCorp.value.bizLicense = '';
}

// 기업소개서 업로드
const uploadFileCorpIntro = (corpUpdate) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpIntro',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.corpIntroName = result.originalFilename;
            corpUpdate.corpIntroSize = result.fileSize;
            corpUpdate.corpIntroDir = result.blobUrl;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 기업소개서 삭제
const removeFileCorpIntro = (corpUpdate) => {
  corpUpdate.corpIntroName = '';
  corpUpdate.corpIntroSize = '';
  corpUpdate.corpIntroDir = '';
}


// 회사 소개 영상 업로드
const uploadFileCorpIntroMov = (corpUpdate) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'corpInfoURL',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            corpUpdate.introMovName = result.originalFilename;
            corpUpdate.introMovSize = result.fileSize;
            corpUpdate.introMovDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            corpUpdateIntroMovFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 회사 소개 영상 삭제
const removeFileCorpIntroMov = (createCorp) => {
  createCorp.introMovName = '';
  createCorp.introMovSize = '';
  createCorp.introMovDir = '';
  corpUpdateIntroMovFileNameSize.value = '';
  inputError.value.introMov = '';
}

// 취소
const clickCancel = () => {
  goBack();
  $alert(`기업정보 ${route.query.mode === 'create' ? '등록' : '수정'}이 취소되었습니다.`);
}

const goBack = (updated = false) => {
  emit('go-back', updated);
  const targetCorpId = corporation.value.corpId || route.params.id;

  if (!targetCorpId) {
    return;
  }

  router.replace({
    name: 'CorporationDetail',
    params: { id: targetCorpId },
    query: { tab: 'companyInfo' },
  });
}

// 수정 완료
const updateCorporation = () => {
  let isInvalid = false;
  let corpId = corporation.value.corpId;

  // 기본 기본 정보
  // 사업자등록번호
  const { corpName } = corpUpdate.value;
  errorInputCorp.value.bizNum = '';

  const bizNum = corpUpdate.value.bizNum ? corpUpdate.value.bizNum.replace('-','').replace('-','') : corpUpdate.value.bizNum;
  if(!bizNum || bizNum.length !== 10) {
    errorInputCorp.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
    isInvalid = true;
  }

  // 대표자명, 사업장소재지, 업종
  const { ceoName, residenceArea1, residenceArea2, bizType } = corpUpdate.value;
  errorInputCorp.value.ceoName = '';
  errorInputCorp.value.residenceArea = '';
  errorInputCorp.value.bizType = '';

  // 대표자명
  if(!ceoName) {
    errorInputCorp.value.ceoName = '대표자명을 입력하세요.';
    isInvalid = true;
  }

  //사업장소재지
  if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
      (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
    errorInputCorp.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
    isInvalid = true;
  }

  // 업종
  if(!bizType) {
    errorInputCorp.value.bizType = '업종을 입력하세요.';
    isInvalid = true;
  }

  // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
  const { industryGb, corpGb, employeeNumGb, salesAmtGb } = corpUpdate.value;
  errorInputCorp.value.industryGb = '';
  errorInputCorp.value.corpGb = '';
  errorInputCorp.value.foundYm = '';
  errorInputCorp.value.employeeNumGb = '';
  errorInputCorp.value.salesAmtGb = '';

  // 산업군
  let industryText = corpUpdate.value.industryText;
  if(!industryGb) {
    errorInputCorp.value.industryGb = '산업군을 선택하세요.';
    isInvalid = true;
  } else if(industryGb === '06' && !industryText) {
    errorInputCorp.value.industryGb = '기타 산업군을 입력하세요.';
    isInvalid = true;
  } else if (industryGb !== '06') {
    industryText = '';
  }

  // 기업형태
  let corpText = corpUpdate.value.corpText;
  if(!corpGb) {
    errorInputCorp.value.corpGb = '기업형태를 선택하세요.';
    isInvalid = true;
  } else if(corpGb === '05' && !corpText) {
    errorInputCorp.value.corpGb = '기타 기업형태를 입력하세요.';
    isInvalid = true;
  } else if(corpGb !== '05') {
    corpText = '';
  }

  // 창립연월
  const foundYm = moment(corpUpdate.value.foundYm.replace('.', '')).format("YYYYMM")
  if(!foundYm) {
    errorInputCorp.value.foundYm = '창립연월을 입력하세요.';
    isInvalid = true;
  } else if (foundYm) {
    // console.log(foundYm);
    if(foundYm.length !== 6) {
      errorInputCorp.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
      isInvalid = true;
    } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
        // || Number(nowYm) < Number(startYm)  // 미래 기간
    ) {
      errorInputCorp.value.foundYm = '올바른 기간을 입력하세요.';
      isInvalid = true;
    }
  }

  // 사원수(인원구분)
  if(!employeeNumGb || employeeNumGb === '00') {
    errorInputCorp.value.employeeNumGb = '사원수를 선택하세요.';
    isInvalid = true;
  }

  // 매출액
  if(!salesAmtGb || salesAmtGb === '00') {
    errorInputCorp.value.salesAmtGb = '매출액을 선택하세요.';
    isInvalid = true;
  }

  // 상장, 홈페이지 url
  const { corpPublicYn, corpPublicGb, homeUrl } = corpUpdate.value;
  errorInputCorp.value.corpPublicYn = '';
  errorInputCorp.value.corpPublicGb = '';

  // 상장
  let corpPublicText = corpUpdate.value.corpPublicYn;
  if(!corpPublicYn) {
    errorInputCorp.value.corpPublicYn = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && !corpPublicGb) {
    errorInputCorp.value.corpPublicGb = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
    errorInputCorp.value.corpPublicGb = '기타 상장을 입력하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
    corpPublicText = '';
  }

  // 로고이미지(CI)
  const { ciImgName, ciImgSize, ciImgDir } = corpUpdate.value;
  errorInputCorp.value.ciImg = '';

  if(!ciImgName || !ciImgSize || !ciImgDir) {
    errorInputCorp.value.ciImg = '로고이미지 파일을 선택하세요.';
    isInvalid = true;
  }

  // 사업자등록증
  const { bizLicenseName, bizLicenseSize, bizLicenseDir } = corpUpdate.value;
  errorInputCorp.value.bizLicense = '';

  if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
    errorInputCorp.value.bizLicense = '사업자등록증 파일을 선택하세요.';
    isInvalid = true;
  }

  // 기업 추가 정보 (기업 소개, 주요 연혁, 기업 소개서, 기업 소개 영상)
  const { corpIntro, corpHistory, corpIntroName, corpIntroSize, corpIntroDir, introMovGb, introMovName, introMovSize, introMovDir, introYoutubeUrl } = corpUpdate.value;

  // 저장 처리
  if(!isInvalid) {
    let paramObj = {
      corpId: corporation.value.corpId,
      bizNum: corpUpdate.value.bizNum ? corpUpdate.value.bizNum.replace('-','').replace('-','') : corpUpdate.value.bizNum,
      corpName: corpUpdate.value.corpName,
      ceoName: corpUpdate.value.ceoName,
      residenceArea1: corpUpdate.value.residenceArea1,
      residenceArea2: corpUpdate.value.residenceArea2,
      bizType: corpUpdate.value.bizType,
      industryGb: corpUpdate.value.industryGb,
      industryText: industryText,
      corpGb: corpUpdate.value.corpGb,
      corpText: corpText,
      foundYm: corpUpdate.value.foundYm ? corpUpdate.value.foundYm.replace('.','').replace('.','') : corpUpdate.value.foundYm,
      employeeNumGb: corpUpdate.value.employeeNumGb,
      salesAmtGb: corpUpdate.value.salesAmtGb,
      corpPublicYn: corpUpdate.value.corpPublicYn,
      corpPublicGb: corpUpdate.value.corpPublicGb,
      corpPublicText: corpPublicText,
      homeUrl: corpUpdate.value.homeUrl,
      ciImgName: corpUpdate.value.ciImgName,
      ciImgSize: corpUpdate.value.ciImgSize,
      ciImgDir: corpUpdate.value.ciImgDir,
      bizLicenseName: corpUpdate.value.bizLicenseName,
      bizLicenseSize: corpUpdate.value.bizLicenseSize,
      bizLicenseDir: corpUpdate.value.bizLicenseDir,
      corpIntro: corpUpdate.value.corpIntro,
      corpHistory: corpUpdate.value.corpHistory,
      corpIntroName: corpUpdate.value.corpIntroName,
      corpIntroSize: corpUpdate.value.corpIntroSize,
      corpIntroDir: corpUpdate.value.corpIntroDir,
      introMovGb,
      introMovName,
      introMovSize,
      introMovDir,
      introYoutubeUrl,
    }
    mypageCorpInfoService.updateCorpInfo(paramObj)
      .then(async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        if (route.query.mode === 'create') {
          $alert(["기업정보 등록이 완료되었습니다.", "등록된 기업정보는","추후 언제든 수정이 가능합니다."]);
        } else {
          $alert("기업정보 수정이 완료되었습니다.");
        }
        goBack(true);
      }
    }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

//무결성 검사
const validateText = (key, value) => {
  if (key === 'bizNum') {
    errorInputCorp.value.bizNum = !value ? '사업자등록번호를 입력하세요.' : '';
  } else if (key === 'corpName') {
    errorInputCorp.value.corpName = !value ? '기업명을 입력하세요.' : '';
  } else if (key === 'ceoName') {
    errorInputCorp.value.ceoName = !value ? '대표자명을 입력하세요.' : '';
  } else if (key === 'bizType') {
    errorInputCorp.value.bizType = !value ? '업종을 입력하세요.' : '';
  } else if (key === 'foundYm') {
    errorInputCorp.value.foundYm = !value ? '창립연월을 입력하세요.' : '';
  } else if (key === 'recruitCnt') {
    errorInputRecru.value.recruitCnt = !value ? '모집인원을 입력하세요.' : '';
  } else if (key === 'chargeName') {
    errorInputRecru.value.chargeName = !value ? '성명을 입력하세요.' : '';
  } else if (key === 'chargeDepart') {
    errorInputRecru.value.chargeDepart = !value ? '부서를 입력하세요.' : '';
  } else if (key === 'chargeJob') {
    errorInputRecru.value.chargeJob = !value ? '직위를 입력하세요.' : '';
  } else if (key === 'chargeCompanyNum') {
    errorInputRecru.value.chargeCompanyNum = !value ? '회사 직통번호를 입력하세요.' : '';
  } else if (key === 'chargePhoneNum') {
    errorInputRecru.value.chargePhoneNum = !value ? '휴대폰 번호를 입력하세요.' : '';
  } else if (key === 'chargeEmail') {
    errorInputRecru.value.chargeEmail = !value ? '이메일을 입력하세요.' : '';
  }
}

onMounted(()=>{
  loaded.value = false;
  const { id } = route.params;
  if(!id) {
    goBack();
  } else {
    corporation.value.corpId = id;
    ojfCorporationDetail()
  }
})
</script>
<template>
    <div class="content">
      <div class="sub-title mb-n-sm">
        <h3>기업정보 {{ route.query.mode === 'create' ? '등록' : '수정' }}</h3>
      </div>
      <p>기업 정보는 등록과 동시에 &lt;기업 홍보관&gt;페이지에 공개되므로 반드시 실제 정보를 입력하시기 바랍니다. (<span class="red">*</span>표시는 필수 입력사항입니다.)</p>
      <p class="mt-xs">등록된 기업정보는 [마이페이지 &gt; 기업홍보관 현황]에서 관리가 가능합니다.</p>
      <!-- s : 기업 기본 정보 -->
      <div class="table-form mt-sm">
        <table class="vertical align-left">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th colspan="2">기업 기본 정보</th>
          </tr>
          <tr>
            <th class="mark">사업자등록번호</th>
            <td>
              <KSAInput class="text-box" @input="formatBizNum" v-model="corpUpdate.bizNum" maxLength="15" placeholder="10자리 숫자 입력" />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.bizNum }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">기업명</th>
            <td>
              <KSAInput class="text-box" @input="validateText('corpName', $event.target.value)" v-model="corpUpdate.corpName" maxLength="500" />
              <div>
                <small style="color:#E71414;">{{errorInputCorp.corpName }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">대표자명</th>
            <td>
              <KSAInput class="text-box" @input="validateText('ceoName', $event.target.value)" v-model="corpUpdate.ceoName" maxLength="50" placeholder="대표명을 입력하세요." />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.ceoName }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">사업장소재지</th>
            <td>
              <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.residenceArea }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">업종</th>
            <td>
              <KSAInput class="text-box" v-model="corpUpdate.bizType" @input="validateText('bizType', $event.target.value)" maxLength="50" placeholder="업종을 입력하세요." />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.bizType }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">산업군</th>
            <td>
              <template v-for="option in $gb.INDUSTRY_GB">
                <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="corpUpdate.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                <div class="etc-box" v-if="option.label === '기타' && corpUpdate.industryGb == option.value" >
                  <KSAInput class="text-box" v-model="corpUpdate.industryText" placeholder="기타 산업군을 입력하세요." />
                </div>
              </template>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.industryGb }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">기업형태</th>
            <td>
              <template v-for="option in $gb.CORP_GB">
                <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="corpUpdate.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpGb == option.value" >
                  <KSAInput class="text-box" v-model="corpUpdate.corpText" placeholder="기타 기업형태를 입력하세요." />
                </div>
              </template>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.corpGb }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">창립연월</th>
            <td>
              <KSAInputDateYYYYMM class="text-box" v-model="corpUpdate.foundYm" @input="validateText('foundYm', $event.target.value)" placeholder="YYYY.MM" format="YYYYMM" max-length="5" />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.foundYm }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">사원수</th>
            <td>
              <KSASelect v-if="!corpUpdate.employeeNumGb" class="select" v-model="corpUpdate.employeeNumGb" :options="[{ label: '선택', value: '00' }, ...$gb['EMPLOYEE_NUM_GB']]" />
              <KSASelect v-else class="select" v-model="corpUpdate.employeeNumGb" :options="$gb['EMPLOYEE_NUM_GB']" />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.employeeNumGb }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">매출액</th>
            <td>
              <KSASelect v-if="!corpUpdate.salesAmtGb" class="select" v-model="corpUpdate.salesAmtGb" :options="[{ label: '선택', value: '00' }, ...$gb['SALES_AMT_GB']]" @selectOption="clickSalesAmtGb" />
              <KSASelect v-else class="select" v-model="corpUpdate.salesAmtGb" :options="$gb['SALES_AMT_GB']" @selectOption="clickSalesAmtGb" />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.salesAmtGb }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark" rowspan="2">상장여부</th>
            <td>
              <KSARadioButton class="check-box mr-lg" label="상장" v-model="corpUpdate.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
              <KSARadioButton class="check-box mr-lg" label="비상장" v-model="corpUpdate.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.corpPublicYn }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <td v-if="corpUpdate.corpPublicYn === 'Y'">
              <template v-for="option in $gb.CORP_PUBLIC_GB">
                <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="corpUpdate.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                <div class="etc-box" v-if="option.label === '기타' && corpUpdate.corpPublicGb == option.value" >
                  <KSAInput class="text-box" v-model="corpUpdate.corpPublicText" placeholder="기타 상장을 입력하세요." />
                </div>
              </template>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.corpPublicGb }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th>홈페이지 URL</th>
            <td>
              <KSAInput class="text-box" v-model="corpUpdate.homeUrl" maxLength="200" placeholder="홈페이지 URL을 입력하세요." />
            </td>
          </tr>
          <tr>
            <th class="mark">로고이미지(CI)</th>
            <td class="text-box">
              <div class="grid file">
                <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(corpUpdate)" />
                <KSAInput class="input icon" v-model="corpUpdate.ciImgName" placeholder="파일 선택(1200px X 265px, 300DPI 이미지를 권장합니다.)" disabled />
                <button class="delete" @click="removeFileCiImg(corpUpdate)"><i></i></button>
              </div>
              <small>최대 200MB 까지 첨부 가능</small>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.ciImg }}</small>
              </div>
            </td>
          </tr>
          <tr>
            <th class="mark">사업자등록증</th>
            <td class="text-box">
              <div class="grid file">
                <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(corpUpdate)" />
                <KSAInput class="input icon" v-model="corpUpdate.bizLicenseName" placeholder="파일 선택" disabled />
                <button class="delete" @click="removeFileBizLicense(corpUpdate)"><i></i></button>
              </div>
              <small>최대 200MB 까지 첨부 가능</small>
              <div>
                <small style="color:#E71414;">{{ errorInputCorp.bizLicense }}</small>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <!-- e : 기업 기본 정보 -->
      <!-- s : 기업 추가 정보 -->
      <div class="table-form mt-sm">
        <table class="vertical align-left">
          <colgroup>
            <col width="20%" />
            <col />
          </colgroup>
          <tr>
            <th colspan="2">기업 추가 정보</th>
          </tr>
          <tr>
            <th>기업 소개 영상</th>
            <td class="text-box">
              <KSARadioButton class="check-box mr-lg" label="영상 업로드" v-model="corpUpdate.introMovGb" value="01" @change="resetFile('Y')" />
              <KSARadioButton class="check-box mr-lg" label="유튜브 영상(URL) 등록" v-model="corpUpdate.introMovGb" value="02" @change="resetFile('N')" />
              <div v-if="corpUpdate.introMovGb === '01'">
                <div class="grid file mt-xs">
                  <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntroMov(corpUpdate)" />
                  <KSAInput class="input icon" v-model="corpUpdateIntroMovFileNameSize" placeholder="파일 선택" disabled />
                  <button class="delete" @click="removeFileCorpIntroMov(corpUpdate)"><i></i></button>
                </div>
                <small>최대 500MB 까지 첨부 가능</small>
              </div>
              <div v-else-if="corpUpdate.introMovGb === '02'">
                <KSAInput class="text-box mt-xs" v-model="corpUpdate.introYoutubeUrl" maxLength="200" placeholder="유튜브 영상(URL) 경로를 https://를 포함하여 입력하세요." />
              </div>
            </td>
          </tr>
          <tr>
            <th>기업 소개</th>
            <td>
              <KSACKEditor ref="editorRef" v-model="corpUpdate.corpIntro" />
            </td>
          </tr>
          <tr>
            <th>주요 연혁</th>
            <td>
              <KSACKEditor ref="editorRef" v-model="corpUpdate.corpHistory" />
            </td>
          </tr>
          <tr>
            <th>기업 소개서</th>
            <td class="text-box">
              <div class="grid file">
                <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(corpUpdate)" />
                <KSAInput class="input icon" v-model="corpUpdate.corpIntroName" placeholder="파일 선택" disabled />
                <button class="delete" @click="removeFileCorpIntro(corpUpdate)"><i></i></button>
              </div>
              <small>최대 200MB 까지 첨부 가능</small>
            </td>
          </tr>
        </table>
      </div>
      <!-- e : 기업 추가 정보 -->
      <div class="btn-wrap space-between">
        <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel" />
        <KSASecondaryButton :text="route.query.mode === 'create' ? '등록 완료' : '수정 완료'" @click="updateCorporation" />
      </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
</style>
